import styled, { css } from "styled-components";
import { device } from "../../styles/mediaQueries";

export const Wrapper = styled.div`
  ${({ theme }) => css`
    position: fixed;
    bottom: 0;
    z-index: 5;
    width: 100%;
    display: flex;
    justify-content: center;
    background-color: ${theme.darkTheme.colors.purple};
    padding: ${theme.spacings.smaller};
  `}
`;

export const ContentContainer = styled.div`
  ${({ theme }) => css`
    width: 100%;
    max-width: 725px;
    display: flex;
    justify-content: center;
    align-items: center;
    gap: ${theme.gap.smaller};

    @media (${device.tablet}) {
      gap: ${theme.gap.largest};
    }
  `}
`;

export const LogoContainer = styled.div`
  ${({ theme }) => css`
    display: none;
    max-width: 50px;

    img {
      max-width: 100%;
    }

    @media (${device.tablet}) {
      display: flex;
    }
  `}
`;
export const TextContainer = styled.div`
  ${({ theme }) => css`
    display: flex;
    flex-direction: column;

    h2 {
      font-size: ${theme.font.size.medium};
      margin: 0;
    }
    p {
      font-size: ${theme.font.size.smaller};
      margin: 0;
      display: flex;
      flex-direction: column;
    }

    @media (${device.tablet}) {
      h2 {
        font-size: ${theme.font.size.large};
      }
      p {
        font-size: ${theme.font.size.medium};
        display: block;
      }
    }
  `}
`;

export const ButtonContainer = styled.div`
  ${({ theme }) => css`
    display: flex;
    width: 167px;
  `}
`;
